const mEditionProductTrackingCodesEdit = {
  mEditionProductTrackingCodesEdit: {
    alerts: {
      updateProductoCodigoRastreo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El código de rastreo fue insertado exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      codigo_body: {
        label: 'Copia y pega aquí el código que va dentro de la etiqueta html <body></body>'
      },

      codigo_head: {
        label: 'Copia y pega aquí el código que va dentro de la etiqueta html <head></head>'
      },

      nombre: {
        label: 'Nombre de Código de Rastreo',
        message: '* De 1 a 60 caracteres',
        placeholder: 'Mi Pixel de Facebook'
      }
    },

    validation: {
      codigo_body: {
        required: 'Código de etiqueta <body></body> es requerido.',
        validScript: 'El código ingresado no es válido. El mismo debe estar contenido entre las etiquetas <script></script>.'
      },

      codigo_head: {
        required: 'Código de etiqueta <head></head> es requerido.',
        validScript: 'El código ingresado no es válido. El mismo debe estar contenido entre las etiquetas <script></script>.'
      },

      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracteres.',
        required: 'Nombre de código de rastreo es requerido. De 1 a 60 caracteres.'
      }
    }
  }
}

export default mEditionProductTrackingCodesEdit
